module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"messages":{"today":"Today","yesterday":"Yesterday","copyText":"Copy message","downloadImage":"Download","deleteMessage":"Delete"}},"es":{"messages":{"today":"Hoy","yesterday":"Ayer","copyText":"Copiar mensaje","downloadImage":"Descargar","deleteMessage":"Borrar"}}}')
  delete Component.options._Ctor
}
